export default __webpack_public_path__ + "static/media/PR-Card-eot-1.6c1b8369.jpg";